import {ContextFormatter} from 'common/src/modules/shared/copilot/copilot.types';
import {
  CLCopilotContext,
  CopilotContextKey,
} from 'common/src/modules/shared/copilot/bootstrap/bootstrap.types';
import formatContextPage from 'common/src/modules/shared/copilot/utils/formatContextPage';

function formatCampaignLogicContext(
  prevContext: CLCopilotContext | null,
  currentContext: CLCopilotContext,
): string | null {
  // whether we are in the campaign logic page
  const _campaignLogicPageFormatter: ContextFormatter = (prevContext, currentContext) =>
    formatContextPage(
      CopilotContextKey.CampaignLogic,
      'campaign logic tab',
      prevContext,
      currentContext,
    );

  const formatters = [_campaignLogicPageFormatter];

  return formatters
    .map((formatter) => formatter(prevContext, currentContext))
    .filter(Boolean)
    .join('\n');
}

export default formatCampaignLogicContext;
